import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import get from 'lodash/get';
import cx from 'classnames';
import { Column } from 'web-ui-components/lib/global/layout';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import AccountsStore from '../../stores/AccountsStore';
import ApiUtils from '../../utils/ApiUtils';
import AppStore from '../../stores/AppStore';
import { getCookieContent } from '../../utils/BiocatchUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import { copCheckTriggeredHandler } from '../../utils/COPUtils';
import FaqAnyQuestionsLink from '../common/FaqAnyQuestionLinks';
import {
  GenericChatComponent,
  getChatContent,
} from '../common/GenericChatComponent';
import HashcodeUtils from '../../utils/HashcodeUtils';
import HelpActionCreator from '../../actions/HelpActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import LoaderComponent from '../common/LoaderComponent';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import MoveMoneyApiUtils from '../../utils/MoveMoneyApiUtils';
import MoveMoneyBL from './MoveMoneyBL';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneySME from './sme-user/MoveMoneySME';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import NavigationConfirmationModal from '../common/NavigationConfirmationModal';
import Panel from './Panel';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import PayeeListComponent from './PayeeListComponent';
import PaymentAccountCardInfo from './PaymentAccountCardInfo';
import RepeatPayment from './RepeatPayment_Refactor';
import ReviewPayment from './ReviewPayment_Refactor';
import SavingComponent from './SavingComponent';
import SelectedAccountComponent from './SelectedAccountComponent';
import SessionActionCreator from '../../actions/SessionActionCreator';
import SessionStore from '../../stores/SessionStore';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import SiteHeaderStore from '../../stores/SiteHeaderStore';
import StringConstant from '../../constants/StringConstants';
import SvgIcon from '../common/SvgIcon';
import ThankYou from './ThankYou_Refactor';
import { ToolTipComponent } from '../common/ToolTipComponent';
import UserManagementStore from '../../stores/UserManagementStore';
import VerificationContainer from '../verification/VerificationContainer';
import envConfig from '../../../static/config';
import MoveMoneyPageHeader from './MoveMoneyPageHeader';
import { COP } from 'payments-lib';
import { getSessionInfo } from '../managepayments/ManagePaymentsSMEUtils';
import { NoPreviousCOPTile } from './NoPreviousCOPTile';
import EditPayeePage from './EditPayeePage';
import { formatAddNewPayee } from '../../utils/PayeeUtils';
import { YOUTH_ACCOUNT_PAYMENT_LIMIT } from '../../constants/YouthAccountConstants';
import { hasExceededYouthAccountPaymentLimit } from '../../utils/AccountUtils';
import { StepUpWrapper } from '../session';

const limitSize = BrowserUtils.isMobileView() ? 3 : 5;

let savingOpenFromId;
let savingOpenToId;
let fromCssClassName = '';
let isNominatedUser = false;

class MoveMoneyFromToComponent extends Component {
  constructor(props) {
    super(props);

    this.fromComponent = this.fromComponent.bind(this);
    this.fromClicked = this.fromClicked.bind(this);
    this.fromShowMoreClicked = this.fromShowMoreClicked.bind(this);
    this.onFromSelectClick = this.onFromSelectClick.bind(this);
    this.overlayclick = this.overlayclick.bind(this);
    this.toClicked = this.toClicked.bind(this);
    this.onToSelectClick = this.onToSelectClick.bind(this);
    this.onPayeeClick = this.onPayeeClick.bind(this);
    this.amountChange = this.amountChange.bind(this);
    this.amountBlur = this.amountBlur.bind(this);
    this.showAddPayeePage = this.showAddPayeePage.bind(this);
    this.editClickFromPayee = this.editClickFromPayee.bind(this);
    this.deletePayeeClick = this.deletePayeeClick.bind(this);
    this.continueClick = this.continueClick.bind(this);
    this.showReviewPayment = this.showReviewPayment.bind(this);
    this.onReviewBack = this.onReviewBack.bind(this);
    this.setRepeatData = this.setRepeatData.bind(this);
    this.closePotPopUp = this.closePotPopUp.bind(this);
    this.creditokClick = this.creditokClick.bind(this);
    this.closed = this.closed.bind(this);
    this.navigateToManagePayee = this.navigateToManagePayee.bind(this);
    this.navigateToManagePayments = this.navigateToManagePayments.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.refreshMoveMoney = this.refreshMoveMoney.bind(this);
    this.hideErrorPopUp = this.hideErrorPopUp.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.trackFocusIn = this.trackFocusIn.bind(this);
    this.getParentId = this.getParentId.bind(this);
    this.savingFromOpened = this.savingFromOpened.bind(this);
    this.savingToOpened = this.savingToOpened.bind(this);
    this.handleTokenResponse = this.handleTokenResponse.bind(this);
    this.resetReview = this.resetReview.bind(this);
    this.reduceAmount = this.reduceAmount.bind(this);
    this.goGetB = this.goGetB.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
    this.stayOnPage = this.stayOnPage.bind(this);
    this.leavePage = this.leavePage.bind(this);
    this.keyPressFromTo = this.keyPressFromTo.bind(this);
    this.showError = this.showError.bind(this);
    this.getSideNavData = this.getSideNavData.bind(this);
    this.linkClicked = this.linkClicked.bind(this);
    this.faqAnchorClick = this.faqAnchorClick.bind(this);
    this.getLeaveModalConfig = this.getLeaveModalConfig.bind(this);
    this.hideQuickLinks = this.hideQuickLinks.bind(this);
    this.showQuickLinks = this.showQuickLinks.bind(this);
    this.renderMaxOtpReachedModal = this.renderMaxOtpReachedModal.bind(this);
    this.showCopComponent = this.showCopComponent.bind(this);
    this.handleCopResult = this.handleCopResult.bind(this);
    this.handleKeepAsIs = this.handleKeepAsIs.bind(this);
    this.handleSRD = this.handleSRD.bind(this);
    this.handleCOPCancel = this.handleCOPCancel.bind(this);
    this.handleCOPEdit = this.handleCOPEdit.bind(this);
    this.showEditPayeePage = this.showEditPayeePage.bind(this);
    this.hideEditPayeePage = this.hideEditPayeePage.bind(this);
    this.handleEditSuccess = this.handleEditSuccess.bind(this);
    this.editCOPSuccess = this.editCOPSuccess.bind(this);
    this.handleCOPClick = this.handleCOPClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.setupStore = this.setupStore.bind(this);
    this.buildCopPayeePayload = this.buildCopPayeePayload.bind(this);
    // Effective Warning Methods
    this.handleEwActions = this.handleEwActions.bind(this);
    this.getEwProps = this.getEwProps.bind(this);
    this.state = this.initialState();
  }

  componentWillMount() {
    this.isFirstLoad = true;
    isNominatedUser = UserManagementStore.isNominatedUser();
  }

  componentDidMount() {
    window.addEventListener('message', this.handleTokenResponse);
    SiteHeaderActionCreator.setSideBarFlag(true);

    const currentPayee = MoveMoneyStore.getSelectedPayee();
    const { confirmation_of_payee } = currentPayee;
    const copCheckNeeded = MoveMoneyPayeeStore.getCopCheckNeeded();

    const srdCheckRequired =
      currentPayee.hasOwnProperty('biller_id') ||
      currentPayee.cop_account_type === 'Business';

    const showCOPTile =
      srdCheckRequired &&
      confirmation_of_payee.cop_status !== StringConstant.COP_ACTIVE
        ? copCheckNeeded
        : confirmation_of_payee &&
          confirmation_of_payee.cop_status === StringConstant.COP_INACTIVE;

    this.setState({
      originalReference: currentPayee.reference || '',
      showCOPTile: showCOPTile,
    });

    if (currentPayee) {
      this.setupStore();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      amountFocus,
      appData,
      resetPaymentData,
      resetPaymentFlag,
      deletePayee,
      showLoader,
      callPaymentService,
      content,
      showThankYouPage,
    } = this.props;

    const { showReview, deleteData, selectedPayee } = this.state;
    const hasSideBar = SiteHeaderStore.getSideBarFlag();
    let setSideBar = false;

    if (
      !showThankYouPage &&
      (AccountsStore.getManagePaymentsFlag() ||
        AccountsStore.getManagePayeesFlag())
    )
      setSideBar = true;
    if (setSideBar !== hasSideBar) {
      SiteHeaderActionCreator.setSideBarFlag(setSideBar);
    }

    if (callPaymentService !== prevProps.callPaymentService) {
      this.setState({
        makePaymentCall: callPaymentService,
      });
    }

    if (amountFocus && !prevProps.amountFocus) {
      ReactDOM.findDOMNode(this.refs.amount).focus();
      this.props.hideErrorPopUp(false);
    }

    if (prevProps.amountFocus) {
      ReactDOM.findDOMNode(this.refs.amount).focus();
      this.props.hideErrorPopUp(false);
    }

    if (showReview) {
      sayLandingMessage(content.reviewHeaderTitleMoveMoney);
    } else {
      if (this.isFirstLoad) {
        sayLandingMessage('Move money');
        this.isFirstLoad = false;
      }
    }

    if (resetPaymentData !== prevProps.resetPaymentData) {
      this.resetReview();
      MoveMoneyStore.resetPaymentData();
      resetPaymentFlag();
    }

    if (deletePayee && deleteData.id === selectedPayee.id) {
      this.setState({ selectedPayee: '' });
    }

    if (
      appData.isApiCallInProgress !== prevProps.appData.isApiCallInProgress ||
      showLoader !== prevProps.showLoader
    ) {
      this.setState({ showLoader: showLoader });
    }
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.setSideBarFlag(false);
    window.removeEventListener('message', this.handleTokenResponse);

    SessionActionCreator.clearStepUpSession();
  }

  onStoreChange() {
    const srdResponse = MoveMoneyPayeeStore.getCopCheckNeeded();
    this.setState({ showCOPTile: srdResponse });
  }

  onFromSelectClick(selectedData, selectedPotData = {}) {
    MoveMoneyStore.setSelectedFromAccount(selectedData);
    MoveMoneyStore.setSelectedPotOfFromAccount(selectedPotData);
    const toSelectedAccountData = MoveMoneyBL.isAccountSame(
      selectedData,
      this.state.toSelectedAccount
    )
      ? {}
      : this.state.toSelectedAccount;

    // to refresh amount and repeat payment options
    if (!MoveMoneyStore.getSpendingFlag()) {
      MoveMoneyStore.resetRepeatData();
      this.setState({
        amountValue: '',
        repeatData: MoveMoneyStore.getRepeatData(),
        isAmountValid: false,
      });
    }
    // If user selects same saving account which is selected in tolist
    if (_.isEmpty(toSelectedAccountData)) {
      MoveMoneyStore.setSelectedPotOfToAccount({});
    }
    this.setState({
      fromOpened: false,
      showMoreLimit: limitSize, // Set to initial value when list closed
      fromSelectedAccount: selectedData,
      toSelectedAccount: toSelectedAccountData, // checkSameAccount ? {} : this.state.toSelectedAccount,
      selectedPayee: MoveMoneyBL.isAccountEligibleForPayment(selectedData)
        ? this.state.selectedPayee
        : {},
    });
    this.showError('amount', false);
    ReactDOM.findDOMNode(this.refs.fromAccount).focus();
  }
  onPayeeClick(selectPayeeData) {
    window.scrollTo(0, 0);
    MoveMoneyActionCreator.putSelectedPayee(selectPayeeData); // Need To check best place
    this.showError('amount', false);
    if (!MoveMoneyStore.getSpendingFlag()) {
      MoveMoneyStore.resetRepeatData();
      this.setState({
        amountValue: '',
        repeatData: MoveMoneyStore.getRepeatData(),
        isAmountValid: false,
      });
    }
    const srdCheckRequired =
      selectPayeeData.hasOwnProperty('biller_id') ||
      selectPayeeData.cop_account_type === 'Business';
    if (srdCheckRequired) {
      this.setState({ showLoader: true });
      MoveMoneyPayeeActionCreator.verifySRDPayee(
        `${selectPayeeData.to_account.sort_code}${selectPayeeData.to_account.account_number}`
      );
    }
    const { confirmation_of_payee } = selectPayeeData;
    const showCOPTile =
      confirmation_of_payee &&
      confirmation_of_payee.cop_status === StringConstant.COP_INACTIVE;
    this.setState({
      toOpened: false,
      showMoreLimit: limitSize, // Set to initial value when list closed
      selectedPayee: selectPayeeData,
      originalReference: selectPayeeData.reference,
      toSelectedAccount: {}, // As payee selected so change selected account value to empty
      showCOPTile,
    });
  }
  onReviewBack() {
    this.setState((prevState) => ({
      showReview: false,
      makePaymentCall: false,
      onEWReview: false,
      copAlreadyCalled: !prevState.copAlreadyCalled,
      fromNoPreviousCOP: false,
    }));
    MoveMoneyApiUtils.isSourceIdSame(false);
    MoveMoneyStore.setInReviewFlag(false);

    MoveMoneyStore.refreshPaymentResponse();
    this.props.hideErrorPopUp(false);
  }
  onToSelectClick(selectedData, selectedPotData = {}) {
    MoveMoneyStore.setSelectedToAccount(selectedData);
    MoveMoneyStore.setSelectedPotOfToAccount(selectedPotData);

    if (!MoveMoneyStore.getSpendingFlag()) {
      MoveMoneyStore.resetRepeatData();
      this.setState({
        amountValue: '',
        repeatData: MoveMoneyStore.getRepeatData(),
        isAmountValid: false,
      });
    }
    // MoveMoneyActionCreator.putToSelectedAccount(selectedData); //Surya Added code
    this.setState({
      toOpened: false,
      showMoreLimit: limitSize, // Set to initial value when list closed
      selectedPayee: {}, // As account selected so change payee value to empty
      toSelectedAccount: selectedData,
    });
    this.showError('amount', false);
    ReactDOM.findDOMNode(this.refs.toAccount).focus();
  }
  getLeaveModalConfig() {
    const repeatPaymentOptions = MoveMoneyBL.formFieldsVisible(
      this.state.fromSelectedAccount,
      this.state.toSelectedAccount,
      this.state.selectedPayee
    );

    const leaveModalTitle = this.props.content.siteHeaderModalTitle.replace(
      '{paymentType}',
      repeatPaymentOptions.isTransfer
        ? this.props.content.btnTextTansferPopup
        : this.props.content.btnTextPaymentPopup
    );

    const primaryButtonText =
      this.props.content.leaveMoveMoneyPrimaryButtonText.replace(
        '{paymentType}',
        repeatPaymentOptions.isTransfer
          ? this.props.content.btnTextTansferPopup
          : this.props.content.btnTextPaymentPopup
      );

    const modalConfig = {
      displayLeavePopup: true,
      title: leaveModalTitle,
      body: this.props.content.leaveMoveMoneyBodyText,
      secondaryButtonText: this.props.content.leaveModalSecondaryButtonText,
      primaryButtonText,
    };

    return modalConfig;
  }

  getParentId(element) {
    let currentEle = element;
    let isParent = '';
    if (currentEle) {
      while (currentEle && currentEle.id !== 'moveMoneyContainer') {
        if (currentEle.id === 'toList') {
          isParent = 'toList';
          break;
        } else if (currentEle.id === 'fromList') {
          isParent = 'fromList';
          break;
        } else {
          currentEle = currentEle.parentElement;
        }
      }
    }
    return isParent;
  }

  // TODO Keep in common folder
  getPlusSignSVGIcon(name) {
    return (
      <div className="add-button">
        <div className="add-button__content">
          <svg width="32px" height="32px" viewBox="0 0 48 48" role="img">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g transform="translate(-1652.000000, -210.000000)" fill="#000">
                <g transform="translate(167.000000, 200.000000)">
                  <path
                    d="M1508.99962,55.0007031 C1497.40144,55.0007031 1488.00005,45.5993062 1488.00005,34.000375 C1488.00005,22.4014438 1497.40144,13.0000469 1508.99962,13.0000469 C1520.59781,13.0000469 1529.99995,22.4014438 1529.99995,34.000375 C1529.99995,45.5993062 1520.59781,55.0007031 1508.99962,55.0007031 M1508.99962,10 C1495.74467,10 1485,20.7446679 1485,34.000375 C1485,47.2560821 1495.74467,58.00075 1508.99962,58.00075 C1522.25458,58.00075 1533,47.2560821 1533,34.000375 C1533,20.7446679 1522.25458,10 1508.99962,10 M1510.4644,32.5356021 L1510.4644,24.2209722 C1510.46515,23.4124596 1509.80889,22.7561993 1508.99962,22.7561993 C1508.19111,22.7561993 1507.53485,23.4124596 1507.53485,24.2209722 L1507.53485,32.5356021 L1499.22022,32.5356021 C1498.41171,32.5356021 1497.75545,33.1903623 1497.75545,34.000375 C1497.75545,34.8088876 1498.41171,35.4651479 1499.22022,35.4651479 L1507.53485,35.4651479 L1507.53485,43.7797778 C1507.53485,44.5882904 1508.19111,45.2445507 1508.99962,45.2445507 C1509.80889,45.2445507 1510.4644,44.5882904 1510.4644,43.7797778 L1510.4644,35.4651479 L1518.77903,35.4651479 C1519.58829,35.4651479 1520.2438,34.8088876 1520.2438,34.000375 C1520.2438,33.1903623 1519.58829,32.5356021 1518.77903,32.5356021 L1510.4644,32.5356021 Z"
                    id="icon-add"
                  />
                </g>
              </g>
            </g>
          </svg>
          {name}
        </div>
      </div>
    );
  }

  getSideNavData(isSMEUser) {
    let sideData = [];
    if (AccountsStore.getManagePaymentsFlag()) {
      if (AccountsStore.isCreditCardUser()) {
        sideData.push({
          id: 1,
          name: 'Manage your scheduled payments',
        });
      } else {
        sideData.push({
          id: 1,
          name: 'Manage your Direct Debits, standing orders and other scheduled payments',
        });
      }
    }
    if (AccountsStore.getManagePayeesFlag()) {
      sideData.push({
        id: 2,
        name: isSMEUser
          ? this.props.content.goMangePayeeBtn
          : this.props.content.managePageheaderTitle,
      });
    }
    sideData.push({ id: 3, name: this.props.content.quickLinkPaymentStatus });

    return sideData;
  }

  setRepeatData(repeatData) {
    this.state.repeatData = repeatData;
  }

  amountBlur(e) {
    const amountValue = e.target.value;
    if (this.state.isAmountValid) {
      if (
        amountValue === '.' ||
        parseFloat(amountValue).toFixed(2) === '0.00'
      ) {
        this.state.isAmountValid = false;
        this.showError('amount', true);
        this.setState({ amountValue });
      } else {
        this.setState({
          amountValue: parseFloat(amountValue).toFixed(2).toString(),
        });
      }
    } else {
      if (amountValue.trim().length === 0) {
        this.showError('amount', true);
        this.state.isAmountValid = false;
        return;
      }
    }
  }

  amountChange(event) {
    const value = event.target.value;
    const numericRegExp = /^[0-9]{0,6}(\.[0-9]{0,2})?$/;
    const { OWNER_ROLE, paymentAmountLimit } = StringConstant;
    if (!numericRegExp.test(value)) {
      return;
    }

    const isEmpty = value.trim().length === 0;
    const isOwnerOfSelectedToAccount =
      this.state.toSelectedAccount.role === OWNER_ROLE;
    const hasExceededGlobalPaymentLimit = value > paymentAmountLimit;

    if (hasExceededGlobalPaymentLimit) {
      return;
    }

    this.setState({ amountValue: value });
    if (
      isEmpty ||
      (!isOwnerOfSelectedToAccount &&
        hasExceededYouthAccountPaymentLimit(value))
    ) {
      this.showError('amount', true);
      this.setState({
        isAmountValid: false,
      });
      return;
    }

    this.showError('amount', false);
    this.setState((prevState) => ({
      isAmountValid: true,
      repeatData: {
        ...prevState.repeatData,
        amount: value,
      },
    }));
  }
  amountField() {
    const isDisable = !(
      !_.isEmpty(this.state.fromSelectedAccount) &&
      (!_.isEmpty(this.state.toSelectedAccount) ||
        !_.isEmpty(this.state.selectedPayee)) &&
      !this.state.showCOPTile
    );
    // _.isEmpty(this.state.toSelectedAccount) && _.isEmpty(this.state.selectedPayee); // TODO for Review Page
    let amountClassName = cx({
      'choose choose--amount': true,
      'choose--disabled': isDisable || this.state.showReview,
      //'choose--disabled': this.state.showReview, // TODO review page
    });

    if (this.state.showReview) return null;

    return (
      <div className={amountClassName}>
        {!_.isEmpty(this.state.fromSelectedAccount) &&
          !_.isEmpty(this.state.toSelectedAccount) && (
            <div className="choose__header">
              <div className="choose__header__title choose__header__title--amount">
                <span id="aria-amount-header">Amount</span>
              </div>
            </div>
          )}
        <div className="choose-toggler">
          <div className="c-field" ref="amountComponent">
            <div className="c-field__controls">
              <div className="c-field__prepend">
                <span className="c-field__addon" aria-hidden="true">
                  &pound;
                </span>
                {isDisable ? (
                  <input
                    className="c-field__input"
                    id="amtId"
                    type="text"
                    name="amount"
                    value={this.state.amountValue}
                    disabled
                  />
                ) : this.state.showReview ? (
                  <div className="c-field__input c-field__input--amount">
                    <span className="u-visually-hidden">
                      Amount in pounds and pence
                    </span>
                    {this.state.amountValue}
                  </div>
                ) : (
                  <input
                    className="c-field__input"
                    type="text"
                    data-parent="amtErr"
                    id="amtId"
                    name="amount"
                    aria-required="true"
                    aria-invalid="false"
                    onChange={this.amountChange}
                    onBlur={this.amountBlur}
                    autoComplete="off"
                    value={this.state.amountValue}
                    ref="amount"
                    readOnly={this.state.showReview}
                  />
                )}
              </div>
              {isDisable || this.state.showReview ? '' : this.returnLimitLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }
  checkAmount(amt) {
    let error = false;

    if (
      MoveMoneyStore.getSelectedFromPot() !== undefined &&
      MoveMoneyStore.getSelectedFromPot().balance !== undefined
    ) {
      if (amt > MoveMoneyStore.getSelectedFromPot().balance) {
        error = true;
      }
    } else {
      error = false;
    }
    return error;
  }
  checkFormValid() {
    if (
      (_.isEmpty(this.state.selectedPayee) &&
        _.isEmpty(this.state.toSelectedAccount)) ||
      !this.state.isAmountValid ||
      _.isEmpty(this.state.fromSelectedAccount)
    ) {
      return false;
    } else {
      return true;
    }
  }
  checkKeyPress(e) {
    MoveMoneyBL.showMoreFocusPrevElement(e, this.fromShowMoreClicked);
  }

  closeErrorModal() {
    const sourceId = HashcodeUtils.getSourceId();
    this.setState({ showReview: false, sourceId });
    MoveMoneyStore.refreshPaymentResponse();
    MoveMoneyStore.setInReviewFlag(false);
    this.props.hideErrorPopUp(false);
  }

  // Sets the state for confirmCancel on cancel click
  closePotPopUp() {
    this.setState({
      potError: false,
    });
  }
  // Sets the state for confirmCancel on cancel click
  closed() {
    this.setState({
      confirmCancel: false,
    });
  }
  // TODO : Refactor this function
  continueClick(repeatData) {
    if (
      this.state.copCancelled &&
      /**
       * If the payment reference has been changed while the User has been at the
       * Edit Payee Screen, signal that we need to perform a CoP Check.
       *
       * @note changed the following line to accept `repeatData` value of `null`
       * {@link https://wearevm.atlassian.net/browse/ENT-9448 ENT-9448}
       */
      this.state.originalReference !== repeatData?.reference
    ) {
      this.setState({ callCOP: true });
    } else {
      // && errors === false (errors === false)
      if (this.state.amountValue > 0) {
        if (MoveMoneyStore.getCreditPopUp() === true) {
          this.setState({
            confirmCancel: true,
            // showReview: true,
            repeatData,
          });
          MoveMoneyStore.setInReviewFlag(true);
        } else if (this.checkAmount(this.state.amountValue)) {
          this.setState({ potError: true });
        } else {
          if (
            _.isEmpty(this.state.toSelectedAccount) &&
            this.state.amountValue > StringConstant.paymentAmountLimit
          ) {
            this.refs.amount.focus();
            return;
          }
          MoveMoneyStore.setInReviewFlag(true);
          this.setState((state) => ({
            showEditPayee: false,
            showReview: true,
            repeatData: {
              ...repeatData,
              amount: state.amountValue,
            },
          }));
        }
      }
    }
  }
  // Sets the state for confirmCancel on Ok click
  creditokClick() {
    this.setState({
      confirmCancel: false,
    });
    this.state.repeatData.amount = this.state.amountValue;
    this.setState({
      showReview: true,
      // repeatData,
    });
  }
  deletePayeeClick(data) {
    this.setState({ deleteData: data });
    this.props.deletePayeeClick(data);
  }

  displayFromAccountsDropdown() {
    // TO CHECK is condition needed?
    const displayListClass = this.state.fromOpened
      ? ' is-open fadeIn animated'
      : '';
    return (
      <ul
        id="fromList"
        className={`col-md1-8 account-card-list account-card-list--from${displayListClass}`}
        aria-labelledby="fromAccount"
        role="application"
        aria-controls="st1"
      >
        {/* ---FROM Account-list----*/}
        <h3
          id="yourAccountFrom"
          className="account-card-list__type account-card-list__type--from"
        >
          Your accounts
        </h3>
        <ul
          className="account-card-list__accounts-list"
          role="listbox"
          aria-labelledby="yourAccountFrom"
        >
          {this.showFromAccounts(StringConstant.fromList)}
          {this.renderShowMoreButtonFrom()}
        </ul>
      </ul>
    );
  }

  displayToAccountsDropdown() {
    // TO CHECK is condition needed? OR Refactor
    let acctClass;
    let payeeClass;
    let listClass;
    const displayListClass = this.state.toOpened
      ? 'is-open fadeIn animated'
      : '';
    const isAccountEnable = MoveMoneyStore.enableToAccounts(); // TODO: Need To change
    const isPayeeEnable = MoveMoneyStore.enablePayee();
    // MoveMoneyBL.shouldShowPayee(this.state.fromSelectedAccount, this.state.toSelectedAccount, this.state.selectedPayee);
    if (isAccountEnable && isPayeeEnable) {
      listClass = `col-md1-24 account-card-list account-card-list--to ${displayListClass}`;
      payeeClass = 'col-md1-16';
      acctClass = 'col-md1-8';
    } else if (isAccountEnable && !isPayeeEnable) {
      listClass = `offset-xl1-8 col-xl1-8 offset-lg1-8 col-lg1-8 offset-md1-8 col-md1-8 account-card-list account-card-list--to ${displayListClass}`;
      acctClass = 'col-sm1-24';
    } else if (!isAccountEnable && isPayeeEnable) {
      listClass = `offset-xl1-8 col-xl1-16 offset-lg1-8 col-lg1-16 offset-md1-8 col-md1-16 account-card-list account-card-list--to ${displayListClass}`;
      payeeClass = 'col-sm1-24';
    }

    return (
      // <div className="block pos-r">
      <ul
        id="toList"
        className={listClass}
        aria-labelledby="toAccount"
        role="application"
        aria-controls="st1"
      >
        <div className="row">
          {/* ---Account-list----*/}
          <div className={acctClass}>
            <h3 className="account-card-list__type" id="yourAccountsTo">
              Your accounts
            </h3>
            <ul
              className="account-card-list__accounts-list"
              role="region"
              aria-labelledby="yourAccountsTo"
            >
              {this.showToAccounts()}
              {this.renderShowMoreButtonFrom()}
            </ul>
          </div>

          {/* ----Payee List----*/}
          {isPayeeEnable ? (
            <PayeeListComponent
              payeeList={this.props.payeeList}
              payeeClass={payeeClass}
              onPayeeClick={this.onPayeeClick}
              showAddPayeePage={this.showAddPayeePage}
              editClickFromPayee={this.editClickFromPayee}
              deletePayeeClick={this.deletePayeeClick}
              content={this.props.content}
            />
          ) : (
            ''
          )}
        </div>
      </ul>
      // </div>
    );
  }
  // function to tell parent edit tile is clicked
  editClickFromPayee(data) {
    this.props.editClickFromPayee(data);
  }

  faqAnchorClick() {
    HelpActionCreator.backSetUrl(
      'WEB-OPEN-MOVEMONEY',
      this.props.content.anyQuestionURLForLimits
    );
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
  }
  fromClicked() {
    MoveMoneyStore.setParentClick(true, 'fromList');
    this.setState({
      fromOpened: true,
      toOpened: false,
      potOpenFromState: false, // Closing if already opened
    });
  }

  fromComponent() {
    let click;
    let fromClassName;
    const fromBtnClassName = cx({
      'choose-toggler': true,
      'choose-toggler--rendercard': !_.isEmpty(this.state.fromSelectedAccount),
      // 'active': ?, // TO DO when to keep active
    });
    if (this.state.showReview) {
      fromClassName = 'choose choose--from choose--disabled';
      click = () => {
        return false;
      };
    } else {
      fromClassName = 'choose choose--from';
      click = this.fromClicked;
    }

    const isFromAccountEmpty = _.isEmpty(this.state.fromSelectedAccount);
    const ariaLabelledBy = 'aria-from-prefix aria-account-from';

    !isFromAccountEmpty
      ? (fromCssClassName = 'choose__header__title--from')
      : (fromCssClassName = '');

    return (
      <div className={fromClassName}>
        <div className="choose__header">
          <div className={`choose__header__title ${fromCssClassName}`}>
            <span id="aria-from-prefix">From</span>
          </div>
        </div>
        {this.state.showReview ? (
          <div
            id="fromAccount"
            ref="fromAccount"
            role="presentation"
            className={fromBtnClassName}
            onClick={click}
            aria-labelledby={ariaLabelledBy}
            disabled
          >
            {this.getPlusSignSVGIcon('From')}
            {_.isEmpty(this.state.fromSelectedAccount)
              ? ''
              : this.renderSelectedFromAccount(this.state.fromSelectedAccount)}
          </div>
        ) : (
          <div
            id="fromAccount"
            ref="fromAccount"
            role="button"
            className={fromBtnClassName}
            onClick={click}
            onKeyDown={this.keyPressFromTo}
            data-toggle="dropdown"
            aria-expanded={this.state.fromOpened}
            aria-haspopup="true"
            aria-label={
              isFromAccountEmpty ? 'Select an account to pay from' : undefined
            }
            aria-labelledby={isFromAccountEmpty ? undefined : ariaLabelledBy}
            tabIndex="0"
          >
            {this.getPlusSignSVGIcon('From')}
            {_.isEmpty(this.state.fromSelectedAccount)
              ? ''
              : this.renderSelectedFromAccount(this.state.fromSelectedAccount)}
          </div>
        )}
        {this.state.fromOpened && this.displayFromAccountsDropdown()}
      </div>
    );
  }
  fromShowMoreClicked() {
    let limit = this.state.showMoreLimit + limitSize;
    this.setState({
      showMoreLimit: limit,
    });
  }
  goGetB() {
    this.props.hideErrorPopUp(false);
  }
  handleTokenResponse(e) {
    if (
      e.data === 'success' ||
      e.data === 'error' ||
      e.data === 'cancel' ||
      e.data === 'failed'
    ) {
      // to ignore biocatch postMessage response
      this.props.disableSoftTokenAlternative();
      if (e.data === 'success') {
        this.props.hideErrorPopUp(false);
        MoveMoneyApiUtils.isSourceIdSame(true);
        window.setTimeout(() => this.setState({ makePaymentCall: true }), 0);
      } else if (e.data === 'cancel') {
        const sourceId = HashcodeUtils.getSourceId();
        this.setState({
          showReview: false,
          makePaymentCall: false,
          sourceId,
        });

        MoveMoneyApiUtils.isSourceIdSame(false);
        MoveMoneyStore.setInReviewFlag(false);

        MoveMoneyStore.refreshPaymentResponse();
        this.props.hideErrorPopUp(false);
      } else if (e.data === 'error') {
        SessionActionCreator.requestAccessTokenReset(true);
      }
      if (e.data === 'failed') {
        this.setState({
          showMaxOTPReachedModal: true,
        });
      }
    }
  }
  hideErrorPopUp() {
    MoveMoneyStore.refreshPaymentResponse();
    this.props.hideErrorPopUp(false);
  }
  hideQuickLinks() {
    if (this.state.showQuickLink) {
      this.setState({ showQuickLink: false });
    }
  }
  initialState() {
    const repeatData = MoveMoneyStore.getRepeatData();
    let isAmountValid = false;
    if (repeatData.amount.toString().length > 0) {
      isAmountValid = true;
    }
    const { hasPaymentCapability, isSMEUser, hideQuickLinks } = this.props;
    return {
      fromOpened: this.isFromEditPayee(),
      showMoreLimit: limitSize,
      fromSelectedAccount: MoveMoneyStore.getSelectedFromAccount(),
      toOpened: false,
      toSelectedAccount: MoveMoneyStore.getSelectedToAccount(),
      selectedPayee: MoveMoneyStore.getSelectedPayee(),
      amountValue: repeatData.amount,
      isAmountValid,
      showReview: false,
      repeatData,
      potError: false,
      confirmCancel: false,
      showLoader: false,
      potOpenFromState: false,
      potOpenToState: false,
      deleteData: '',
      makePaymentCall: this.props.callPaymentService,
      reviewManagePopUp: false,
      navigateManagePayee: false,
      showQuickLink: hideQuickLinks
        ? !hideQuickLinks
        : (isSMEUser && hasPaymentCapability) || !isSMEUser,
      showMaxOTPReachedModal: false,
      effectiveWarningError: false,
      continueOnReview: false,
      onEWReview: false,
      ewCurrentPage: '',
      sourceId: HashcodeUtils.getSourceId(),
      callCOP: false,
      user: UserManagementStore.getCADetails(),
      copCheckClicked: false,
      showEditPayee: false,
      editPayeeDetails: null,
      showCopTile: false,
      copAlreadyCalled: false,
      fromNoPreviousCOP: false,
      referenceEdited: false,
      copCancelled: false,
      keepAsIs: false,
    };
  }
  isFromEditPayee() {
    // getSelectedToAccount   getSelectedToPot
    return (!_.isEmpty(MoveMoneyStore.getSelectedPayee()) &&
      _.isEmpty(MoveMoneyStore.getSelectedFromAccount())) ||
      (!_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
        _.isEmpty(MoveMoneyStore.getSelectedFromAccount()))
      ? true
      : false;
  }
  keyPressFromTo(e) {
    if (
      e.which === 13 ||
      e.keyCode === 13 ||
      e.which === 32 ||
      e.keyCode === 32
    ) {
      if (e.target && e.target.id === 'fromAccount') {
        const status = !this.state.fromOpened;
        if (status) {
          MoveMoneyStore.setParentClick(true, 'fromList');
        } else {
          ReactDOM.findDOMNode(this.refs.fromAccount).focus();
        }
        this.setState({
          fromOpened: status,
          toOpened: false,
          potOpenFromState: false,
        });
      } else if (e.target && e.target.id === 'toAccount') {
        const status = !this.state.toOpened;
        if (status) {
          MoveMoneyStore.setParentClick(true, 'toList');
        } else {
          ReactDOM.findDOMNode(this.refs.toAccount).focus();
        }
        this.setState({
          fromOpened: false,
          toOpened: status,
          potOpenToState: false,
        });
      }
      e.preventDefault();
    }
    if (e.which === 40 || e.keyCode === 40) {
      if (e.target && e.target.id === 'fromAccount' && this.state.fromOpened) {
        const fromList = document.getElementById('fromList');
        const list = fromList.getElementsByClassName(
          'account-card-list__accounts-list'
        );
        if (list.length === 1) {
          list[0].firstChild.focus();
        }
      } else if (
        e.target &&
        e.target.id === 'toAccount' &&
        this.state.toOpened
      ) {
        const toList = document.getElementById('toList');
        const list = toList.getElementsByClassName(
          'account-card-list__accounts-list'
        );
        if (list.length === 1) {
          list[0].firstChild.focus();
        }
      }
    }
  }
  leavePage(e) {
    if (this.state.navigateManagePayee === true) {
      this.props.navigateToManagePayee(e);
    } else {
      this.props.navigateToManagePayments(e);
    }
  }
  linkClicked(e) {
    const currentId = parseInt(e.currentTarget.id);
    switch (currentId) {
      case 1:
        this.navigateToManagePayments(e);
        break;
      case 2:
        this.navigateToManagePayee(e);
        break;
      case 3:
        ManagePaymentActionCreator.saveNavigationReference(
          StringConstant.WEB_TASK_MOVE_MONEY
        );
        InternetBankingActions.navigateToWebTask(
          StringConstant.WEB_TASK_PAYMENT_STATUS
        );
        break;
    }
  }
  navigateToManagePayee(e) {
    if (MoveMoneyStore.getReviewFlag()) {
      this.setState({ reviewManagePopUp: true });
    }
    this.props.navigateToManagePayee(e);
  }
  navigateToManagePayments(e) {
    if (MoveMoneyStore.getReviewFlag()) {
      this.setState({
        reviewManagePopUp: this.state.showReview,
      });
      this.state.navigateManagePayee = false;
    } else {
      this.props.navigateToManagePayments(e);
    }
  }
  overlayclick() {
    this.setState({
      fromOpened: false,
      toOpened: false,
    });
  }
  reduceAmount() {
    this.setState({ showReview: false });
    MoveMoneyStore.refreshPaymentResponse();
    this.props.hideErrorPopUp(true);
  }
  refreshMoveMoney() {
    this.props.refreshMoveMoney();
    this.setState(this.initialState());
  }
  handleRefreshForRepeatingPotPaymentSetup = () => {
    const { handleRefreshForRepeatingPotPaymentSetup } = this.props;

    this.setState(this.initialState());
    handleRefreshForRepeatingPotPaymentSetup();
  };
  resetReview() {
    this.setState({
      showReview: false,
      fromSelectedAccount: '',
      toOpened: false,
      toSelectedAccount: '',
      selectedPayee: '',
      amountValue: '',
      potError: false,
      confirmCancel: false,
      showLoader: false,
      potOpenFromState: false,
      potOpenToState: false,
      repeatData: {},
    });
  }
  returnLimitLink() {
    // readOnly
    let showLimitLink = true;
    if (
      !_.isEmpty(this.state.fromSelectedAccount) &&
      !_.isEmpty(this.state.toSelectedAccount) &&
      _.isEmpty(this.state.selectedPayee)
    ) {
      showLimitLink = false;
    } else showLimitLink = true;
    const linkA = (
      <p className="c-movemoney__links">
        <a
          href="javascript:;"
          aria-describedby="popover-positioned-bottom"
          onClick={this.transactionLimit}
          role="button"
        >
          {this.props.content.limitLink}
          <span className="tl-apply">{this.props.content.apply}</span>
        </a>
      </p>
    );
    const hasExceededYouthAccountAmount =
      AccountsStore.isYouthAccount() &&
      this.state.amountValue > YOUTH_ACCOUNT_PAYMENT_LIMIT;
    if (MoveMoneyStore.getPaymentType()) {
      return (
        <div>
          <div
            className="c-field__message"
            ref="amountMessage"
            id="amountErr"
            role="alert"
          >
            <p>{this.props.content.amountErrorMessage}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div
            className="c-field__message"
            ref="amountMessage"
            id="amountErr"
            role="alert"
            data-test-id="amount-error-message"
          >
            <p>
              {hasExceededYouthAccountAmount
                ? this.props.content.youthAccountAmountExceededMessage
                : this.props.content.amountErrorMessage}
            </p>
          </div>
          <div className="amount-limits type--jura">
            <div className="pos-r">
              {showLimitLink ? (
                <ToolTipComponent
                  trigger="manual"
                  childComponent={linkA}
                  placement="bottom"
                  popoverChildComponent={
                    <p className="type--jura">
                      For information about transaction limits,{' '}
                      <FaqAnyQuestionsLink
                        data={this.props.data}
                        content={this.props.content}
                        onClick={this.faqAnchorClick}
                      />
                    </p>
                  }
                  sectionClass="text-left"
                  titleFlag={false}
                  subTitleClassFlag={false}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      );
    }
  }

  savingFromOpened(savingId) {
    this.setState({ potOpenFromState: true });
    savingOpenFromId = savingId;
  }
  savingToOpened(savingId) {
    this.setState({ potOpenToState: true });
    savingOpenToId = savingId;
  }
  // function to tell parent paysomeonenew tile is clicked
  showAddPayeePage(e) {
    this.props.showAddPayeePage(e);
  }

  showError(name, show) {
    if (this.refs[`${name}Component`]) {
      if (show) {
        this.refs[`${name}Component`].classList.add('c-field--error');
      } else {
        this.refs[`${name}Component`].classList.remove('c-field--error');
      }
    }
  }

  // TODO: MERGE showFromAccounts and showToAccounts methods
  showFromAccounts(listName) {
    let accountComponent;
    let click;
    let accounts;
    if (listName === StringConstant.fromList) {
      // 'From' accounts and from click event handler
      click = this.onFromSelectClick;
      accounts = this.props.fromAccounts.slice(0, this.state.showMoreLimit);
    } else {
      // 'TO' accounts and from click event handler
      click = this.onToSelectClick;
      accounts = this.props.toAccounts.slice(0, this.state.showMoreLimit);
    }
    const accountList = _.map(accounts, (account, index) => {
      if (MoveMoneyBL.shouldRenderAsPaymentCard(account)) {
        accountComponent = (
          <PaymentAccountCardInfo
            key={index}
            data={account}
            index={index}
            onClick={click}
            name={listName}
          />
        );
      } else {
        const fromSelectedPot = MoveMoneyStore.getSelectedPotOfFromAccount(
          account.id
        );
        const toSelectedPot = MoveMoneyStore.getSelectedPotOfToAccount(
          account.id
        );
        let fromAvailablePot = '';
        if (
          !_.isEmpty(MoveMoneyStore.getSelectedAccount()) &&
          MoveMoneyStore.getSelectedAccount().id === account.id &&
          _.isEmpty(MoveMoneyStore.getSelectedFromPot())
        ) {
          fromAvailablePot = MoveMoneyStore.getSelectedAccount();
        }
        let isSavingPotOpen; //= (!_.isEmpty(fromSelectedPot) || (!_.isEmpty(MoveMoneyStore.getSelectedAccount()) && MoveMoneyStore.getSelectedAccount().id === account.id && _.isEmpty(MoveMoneyStore.getSelectedFromPot())));
        if (this.state.potOpenFromState) {
          if (account.id === savingOpenFromId) {
            isSavingPotOpen = true;
          } else {
            isSavingPotOpen = false;
          }
        } else if (
          !_.isEmpty(fromSelectedPot) ||
          (!_.isEmpty(MoveMoneyStore.getSelectedAccount()) &&
            MoveMoneyStore.getSelectedAccount().id === account.id &&
            _.isEmpty(MoveMoneyStore.getSelectedFromPot()))
        ) {
          isSavingPotOpen = true;
        }

        accountComponent = (
          <SavingComponent
            key={index}
            index={index}
            data={account}
            content={this.props.content}
            onClick={click}
            name={listName}
            potOpen={isSavingPotOpen}
            fromSelectedPot={fromSelectedPot}
            fromAvailablePot={fromAvailablePot}
            toSelectedPot={toSelectedPot}
            savingOpened={this.savingFromOpened}
          />
        );
      }
      return accountComponent;
    });
    return accountList;
  }

  showLoader() {
    return <LoaderComponent type="large" />;
  }
  showQuickLinks() {
    const { hasPaymentCapability, isSMEUser } = this.props;
    const showQuickLink = (isSMEUser && hasPaymentCapability) || !isSMEUser;
    this.setState({ showQuickLink });
  }

  getEwProps() {
    return {
      session: {
        clientContext: ApiUtils.getClientContext(),
        accessToken:
          SessionStore.getURLTokenValue() ||
          SessionStore.getToken()['access_token'],
        bankId: SessionStore.getSessionBankID(),
      },
      envConfig,
    };
  }

  handleSRD() {
    this.setState({
      callCOP: true,
    });
  }

  showCopComponent(formData) {
    const currentPayee = MoveMoneyStore.getSelectedPayee();

    window.scroll(0, 0);
    const reference = formData ? formData.reference : currentPayee.reference;

    this.setState({
      callCOP: MoveMoneyPayeeStore.getCopCheckNeeded(),

      selectedPayee: {
        ...currentPayee,
        reference,
      },
      editPayeeDetails: formData || null,
      referenceEdited: false,
    });
  }

  handleCOPCancel() {
    this.setState({
      callCOP: false,
      copCancelled: true,
    });
  }

  handleCOPEdit() {
    this.setState({
      callCOP: false,
      isPerson: true,
      defaultState: true,
      showHeader: true,
      referenceEdited: false,
    });
    this.showEditPayeePage();
  }

  renderCopComponent() {
    const { session, envConfig } = this.props;
    const {
      showEditPayee,
      editPayeeDetails,
      user,
      fromNoPreviousCOP,
      selectedPayee: { to_account, cop_account_name },
    } = this.state;
    const sessionCOPChecks = AppStore.getSessionCOPChecks();
    let cop;
    const accountType =
      this.state.selectedPayee.hasOwnProperty('biller_id') ||
      this.state.selectedPayee?.cop_account_type === 'Business'
        ? 'Business'
        : 'Personal';
    if (showEditPayee) {
      const {
        reference,
        accountName,
        accountNumber,
        customerId,
        sortCode,
        id,
      } = editPayeeDetails;
      cop = {
        accountName,
        accountNumber,
        sortCode,
        accountType,
        reference: reference,
        beneficiaryId: fromNoPreviousCOP ? id : null,
        customerId: customerId,
        customerType: 'retail',
        page: 'MakeMatch',
        tryCount: 1,
      };
    } else {
      const { account_number, sort_code, name } = to_account;
      cop = {
        accountName: cop_account_name || name,
        accountNumber: account_number,
        sortCode: sort_code,
        accountType,
        reference: this.state.selectedPayee.reference,
        beneficiaryId: fromNoPreviousCOP ? this.state.selectedPayee.id : null,
        customerId: user.id,
        customerType: 'retail',
        page: 'MakeMatch',
        tryCount: 1,
      };
    }

    return (
      <COP
        copCheckTriggered={copCheckTriggeredHandler}
        envConfig={envConfig}
        session={getSessionInfo(session)}
        user={this.state.user}
        cop={cop}
        handleCancel={this.handleCOPCancel}
        handleEdit={this.handleCOPEdit}
        handleComplete={(copResult) => {
          this.handleCopResult(copResult, cop);
        }}
        handleKeepAsIs={(copResult) => {
          this.handleKeepAsIs(copResult, cop);
        }}
        sessionCOPChecks={sessionCOPChecks}
      />
    );
  }

  renderStepUpComponent = () => (
    <div className="col-lg1-18">
      <StepUpWrapper
        content={this.props.content}
        handleSuccess={() => {
          MoveMoneyPayeeActionCreator.editPayee({
            payeePayload:
              MoveMoneyPayeeStore.getUnauthorisedBeneficiaryDetails(),
            currentPayee: MoveMoneyStore.getSelectedPayee(),
          });
        }}
        handleCancel={() => {
          SessionActionCreator.clearStepUpSession();

          MoveMoneyStore.resetPaymentData();
          this.refreshMoveMoney();
        }}
      />
    </div>
  );
  isStepUpLoading = () =>
    !this.props.isSMEUser &&
    (SessionStore.isStepUpChallengeLoading() ||
      MoveMoneyPayeeStore.isLoading());

  setupStore(reference, repeatData) {
    const currentPayee = MoveMoneyStore.getSelectedPayee();

    const {
      display_name,
      to_account: { sort_code, name, account_number },
      cop_account_name,
      cop_account_type,
      confirmation_of_payee,
      account: { id: accountId },
      id: beneficiaryId,
      biller_id: billerId,
    } = currentPayee;

    const { billerEdit } = this.props;

    MoveMoneyPayeeActionCreator.updateAllEditFiled({
      fieldValue: {
        display_name,
        sort_code,
        name,
        reference: reference ? reference : currentPayee.reference,
        single_use: false,
        account_number,
        cop_account_name,
        cop_account_type,
        confirmation_of_payee,
      },
      accountId,
      beneficiaryId,
      billerEdit,
      billerId,
    });

    repeatData &&
      this.setState({
        repeatData,
      });
  }

  buildCopPayeePayload(copCheckResult, name) {
    const accountType =
      this.state.selectedPayee.hasOwnProperty('biller_id') ||
      this.state.selectedPayee?.cop_account_type === 'Business'
        ? 'Business'
        : 'Personal';
    if (copCheckResult) {
      const {
        payeeName,
        payeeType,
        result: {
          cop_matching_outcome,
          matching_outcome,
          cop_reason_code,
          reason_code_description,
        } = {},
      } = copCheckResult;

      const matchingOutcome =
        cop_reason_code !== StringConstant.ERR1 &&
        cop_reason_code !== StringConstant.ERR2
          ? cop_matching_outcome
          : null;

      return {
        cop_account_name: payeeName,
        cop_account_type: payeeType,
        confirmation_of_payee: {
          cop_matching_outcome: matchingOutcome,
          cop_reason_code,
          reason_code_description,
          matching_outcome,
        },
      };
    } else {
      // Service down scenario
      return {
        cop_account_name: name,
        cop_account_type: accountType,
        confirmation_of_payee: {
          cop_matching_outcome: null,
          cop_reason_code: null,
          matching_outcome: null,
          reason_code_description: 'CoP Service Unavailable',
        },
      };
    }
  }

  handleCopResult(copResult) {
    const {
      selectedPayee: {
        to_account: { name },
        reference,
      },
    } = this.state;
    const currentPayee = MoveMoneyStore.getSelectedPayee();
    const payeePayload = this.buildCopPayeePayload(copResult, name);

    const showCOPTile =
      copResult &&
      (copResult.cop_reason_code === StringConstant.ERR1 ||
        copResult.cop_reason_code === StringConstant.ERR2);

    this.setState((prevState) => ({
      showEditPayee: false,
      fromNoPreviousCOP: !prevState.fromNoPreviousCOP,
      showCOPTile: showCOPTile,
      callCOP: false,
      showLoader: true,
      copAlreadyCalled: true,
      copCancelled: false,
      showReview: prevState.fromNoPreviousCOP ? false : true,
      originalReference: reference,
    }));

    MoveMoneyPayeeActionCreator.editPayee({ payeePayload, currentPayee });
  }

  // TODO
  handleKeepAsIs(copResult, cop) {
    const {
      to_account: { account_number: accountNumber, sort_code: sortCode },
    } = MoveMoneyStore.getSelectedPayee();

    this.setState(({ fromNoPreviousCOP }) => ({
      fromNoPreviousCOP: !fromNoPreviousCOP,
      showCOPTile: false,
      callCOP: false,
      showLoader: true,
      copAlreadyCalled: true,
      copCancelled: false, // reset cancel flag that gets used in onConintueClick check to invoke
      showReview: !fromNoPreviousCOP,
      keepAsIs: true,
    }));

    const { originalReference } = this.state;
    if (originalReference !== cop.reference) {
      const selectedPayee = get(this.state, 'selectedPayee', {});
      const singleUse = false;
      const addPayee = formatAddNewPayee(
        {
          ...selectedPayee,
          confirmation_of_payee: copResult ? copResult.result : null,
        },
        singleUse
      );
      if (!AppStore.hasUserExceededCopTryLimit(accountNumber, sortCode)) {
        MoveMoneyPayeeActionCreator.editPayee({
          payeePayload: addPayee,
          currentPayee: MoveMoneyStore.getSelectedPayee(),
        });
      }
      this.setState({ originalReference: cop.reference });
    }
    MoveMoneyPayeeActionCreator.verifySRDPayee(`${sortCode}${accountNumber}`);
  }

  showRepeatPayment() {
    // TODO Refactor Repeat Paymant
    // RepeatPayment options
    const repeatPaymentOptions = MoveMoneyBL.formFieldsVisible(
      this.state.fromSelectedAccount,
      this.state.toSelectedAccount,
      this.state.selectedPayee
    );

    return (
      <RepeatPayment
        content={this.props.content}
        repeatAccountValid={MoveMoneyBL.isRepeatePaymentValid(
          this.state.selectedPayee,
          this.state.fromSelectedAccount
        )}
        continueClick={this.continueClick}
        repeatPaymentOptions={repeatPaymentOptions}
        setRepeatData={this.setRepeatData}
        repeatData={this.state.repeatData}
        selectedPayee={this.state.selectedPayee}
        showCopComponent={this.showCopComponent}
        handleSRD={this.handleSRD}
        copAlreadyCalled={this.state.copAlreadyCalled}
        setupStore={this.setupStore}
        originalReference={this.state.originalReference}
        fromSelectedAccount={this.state.fromSelectedAccount}
      />
    );
  }

  shouldShowLoader(currentPayee) {
    return (
      this.state.referenceEdited &&
      this.state.selectedPayee.id === currentPayee.id &&
      !this.state.keepAsIs
    );
  }

  showReviewPayment() {
    const repeatPaymentOptions = MoveMoneyBL.formFieldsVisible(
      this.state.fromSelectedAccount,
      this.state.toSelectedAccount,
      this.state.selectedPayee
    );
    const repeatData = this.state.repeatData;
    const repeatAccountValid = MoveMoneyBL.isRepeatePaymentValid(
      this.state.selectedPayee,
      this.state.fromSelectedAccount
    );
    const availableBalanceData = this.state.fromSelectedAccount.balances;
    let currentBalance;
    _.map(availableBalanceData, (account, index) => {
      if (account.type === 'current') {
        currentBalance = account.amount;
      }
    });
    repeatData.amount = this.state.amountValue;
    const currentPayee = MoveMoneyStore.getSelectedPayee();

    if (this.shouldShowLoader(currentPayee) || this.isStepUpLoading()) {
      return this.showLoader();
    } else {
      return (
        <ReviewPayment
          viewLoader={this.props.viewLoader}
          onReviewBack={this.onReviewBack}
          content={this.props.content}
          showMoveMoneyPage={this.showMoveMoney}
          repeatAccountValid={repeatAccountValid}
          showErrorModal={this.showErrorModal}
          repeatData={repeatData}
          refreshMoveMoney={this.refreshMoveMoney}
          repeatPaymentOptions={repeatPaymentOptions}
          currentBalance={currentBalance}
          makePaymentCall={this.state.makePaymentCall}
          fromAccount={this.state.fromSelectedAccount}
          toAccount={this.state.toSelectedAccount}
          payee={currentPayee}
          showReview={this.state.showReview}
          fromOpened={this.state.fromOpened}
          handleEwActions={this.handleEwActions}
          continueOnReview={this.state.continueOnReview}
          warningId={this.state.sourceId}
          {...this.getEwProps()}
        />
      );
    }
  }
  showToAccounts() {
    let accountComponent;
    // Removing account which is selected in fromlist
    const toAccountsList = MoveMoneyBL.getToAccountList(
      this.props.toAccounts,
      this.state.fromSelectedAccount
    );
    const accounts = toAccountsList.slice(0, this.state.showMoreLimit);

    const accountList = _.map(accounts, (account, index) => {
      if (MoveMoneyBL.shouldRenderAsPaymentCard(account)) {
        accountComponent = (
          <PaymentAccountCardInfo
            key={index}
            data={account}
            index={index}
            onClick={this.onToSelectClick}
            name={StringConstant.toList}
          />
        );
      } else {
        const fromSelectedPot = MoveMoneyStore.getSelectedPotOfFromAccount(
          account.id
        );
        const toSelectedPot = MoveMoneyStore.getSelectedPotOfToAccount(
          account.id
        );
        //= !_.isEmpty(toSelectedPot);
        let isSavingPotOpen;
        if (this.state.potOpenToState) {
          if (account.id === savingOpenToId) {
            isSavingPotOpen = true;
          } else {
            isSavingPotOpen = false;
          }
        } else if (
          !_.isEmpty(toSelectedPot) ||
          (!_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
            MoveMoneyStore.getSelectedToAccount().id === account.id &&
            _.isEmpty(MoveMoneyStore.getSelectedToPot()))
        ) {
          isSavingPotOpen = true;
        }
        accountComponent = (
          <SavingComponent
            key={index}
            index={index}
            data={account}
            content={this.props.content}
            onClick={this.onToSelectClick}
            name={StringConstant.toList}
            potOpen={isSavingPotOpen}
            fromSelectedPot={fromSelectedPot}
            toSelectedPot={toSelectedPot}
            savingOpened={this.savingToOpened}
          />
        );
      }
      return accountComponent;
    });
    return accountList;
  }
  stayOnPage() {
    this.setState({ reviewManagePopUp: false });
  }
  toClicked() {
    MoveMoneyStore.setParentClick(true, 'toList');
    this.setState({
      fromOpened: false, // Closing if already opened
      toOpened: true,
      potOpenToState: false,
    });
  }

  toComponent(data) {
    let click;
    let toCssClassName = '';
    let toClassName = cx({
      'choose choose--to': true,
      // 'choose--review': MoveMoneyStore.getSpendingFlag() || this.state.showReview, // TODO
      'choose--disabled':
        _.isEmpty(this.state.fromSelectedAccount) ||
        MoveMoneyPayeeStore.getCompanyAddedFlag() ||
        MoveMoneyStore.getSpendingFlag() ||
        this.state.showReview, // If FROM account is not selected
    });

    const toBtnClassName = cx({
      'choose-toggler': true,
      'choose-toggler--renderpayee':
        !_.isEmpty(this.state.toSelectedAccount) ||
        !_.isEmpty(this.state.selectedPayee),
      // 'active': ?, // TO DO when to keep active
    });
    if (
      this.state.showReview ||
      MoveMoneyStore.getSpendingFlag() ||
      MoveMoneyPayeeStore.getCompanyAddedFlag()
    ) {
      click = () => {
        return false;
      };
    } else {
      click = this.toClicked;
    }
    const isToAccountPopulated =
      !_.isEmpty(this.state.toSelectedAccount) ||
      !_.isEmpty(this.state.selectedPayee);

    isToAccountPopulated
      ? (toCssClassName = 'choose__header__title--to')
      : (toCssClassName = '');

    const ariaLabelledBy = 'aria-to-prefix aria-account-to aria-payee-to';
    return (
      <div className={toClassName}>
        <div className="choose__header">
          <div className={`choose__header__title ${toCssClassName}`}>
            <span id="aria-to-prefix">To</span>
          </div>
          {AccountsStore.getManagePayeesFlag() && (
            <div className="choose__header__link">
              {MoveMoneyBL.shouldShowPayee(
                this.state.fromSelectedAccount,
                this.state.toSelectedAccount,
                this.state.selectedPayee
              ) ? (
                isNominatedUser ? (
                  ''
                ) : (
                  <a
                    href="javascript:void(0)"
                    className="choose__header__link__tag"
                    onClick={this.showAddPayeePage}
                    role="button"
                  >
                    <SvgIcon
                      style={{
                        'pointer-events': 'none',
                      }}
                      id="icon-plus"
                      width="20px"
                      height="20px"
                      className="choose__header__link__icon"
                      aria-hidden="true"
                      onClick={this.showAddPayeePage}
                    />
                    {this.props.content.payNew}
                  </a>
                )
              ) : (
                ''
              )}
            </div>
          )}
        </div>

        {this.state.showReview ? (
          <div
            id="toAccount"
            ref="toAccount"
            role="presentation"
            className={toBtnClassName}
            onClick={click}
            aria-labelledby={ariaLabelledBy}
            disabled
          >
            {this.getPlusSignSVGIcon('To')}
            {_.isEmpty(this.state.toSelectedAccount)
              ? ''
              : this.renderSelectedToAccount(this.state.toSelectedAccount)}
            {_.isEmpty(this.state.selectedPayee)
              ? ''
              : this.renderSelectedPayee(this.state.selectedPayee)}
          </div>
        ) : (
          <div
            id="toAccount"
            ref="toAccount"
            role="button"
            className={toBtnClassName}
            onClick={click}
            onKeyDown={this.keyPressFromTo}
            data-toggle="dropdown"
            aria-expanded={this.state.toOpened}
            aria-haspopup="true"
            disabled={_.isEmpty(this.state.fromSelectedAccount)}
            aria-disabled={_.isEmpty(this.state.fromSelectedAccount)}
            aria-label={
              isToAccountPopulated ? undefined : 'Choose a payee to pay'
            }
            aria-labelledby={isToAccountPopulated ? ariaLabelledBy : undefined}
            tabIndex="0"
          >
            {this.getPlusSignSVGIcon('To')}
            {_.isEmpty(this.state.toSelectedAccount)
              ? ''
              : this.renderSelectedToAccount(this.state.toSelectedAccount)}
            {_.isEmpty(this.state.selectedPayee)
              ? ''
              : this.renderSelectedPayee(this.state.selectedPayee)}
          </div>
        )}

        {this.state.toOpened && this.displayToAccountsDropdown()}
      </div>
    );
  }

  trackFocusIn(e) {
    if (e.target instanceof Window) {
      if (this.state.toOpened) {
        this.setState({ toOpened: false });
      }
      if (this.state.fromOpened) {
        this.setState({ fromOpened: false });
      }
    } else {
      const ele = document.activeElement;
      if (this.state.toOpened) {
        const menu = this.getParentId(ele);
        if (!(ele.id === 'toAccount' || menu === 'toList')) {
          this.setState({
            toOpened: false,
          });
        }
      }
      if (this.state.fromOpened) {
        const menu = this.getParentId(ele);
        if (!(ele.id === 'fromAccount' || menu === 'fromList')) {
          this.setState({
            fromOpened: false,
          });
        }
      }
    }
  }
  renderMaxOtpReachedModal() {
    const footerButtons = (
      <button
        type="button"
        onClick={() => SessionActionCreator.requestAccessTokenReset(true)}
        className="c-btn c-btn--default c-modal__button"
      >
        OK
      </button>
    );
    const {
      content: { authorisationFailedHeader, authorisationFailedBody },
    } = this.props;
    return (
      <PatternLibModalComponent
        show={this.props.showErrorModalState}
        customClass={'c-modal c-modal--iframe'}
        bsSize={'medium'}
        modalHeading={authorisationFailedHeader}
        modalBody={authorisationFailedBody}
        modalInContainer={false}
        modalFooter={footerButtons}
        closeButton={false}
      />
    );
  }

  renderErrorModal() {
    let modalTitle = '';
    let bodyContent;
    if (this.state.showMaxOTPReachedModal) {
      return this.renderMaxOtpReachedModal();
    }
    if (this.props.otpButton === true) {
      const sourceId = HashcodeUtils.getSourceIdForSoftToken();
      const accessToken =
        SessionStore.getURLTokenValue() ||
        SessionStore.getToken()['access_token'];
      const verificationType = MoveMoneyStore.getVerificationType();
      const bcsid = getCookieContent('bcsid');
      const softTokenURL = envConfig.softTokenURL
        .replace('{tokenParameter}', accessToken)
        .replace('{sourceId}', sourceId)
        .replace('{user_tracking_id}', AppStore.getUserTrackingID());
      const softTokenUrlWithVerificationType = `${softTokenURL}&type=${verificationType}&bcsid=${bcsid}`;
      bodyContent = (
        <iframe
          title="Verification"
          id="statements"
          width="100%"
          height="475px"
          frameBorder="0"
          src={softTokenUrlWithVerificationType}
        />
      );
      return (
        <PatternLibModalComponent
          show={this.props.showErrorModalState}
          customClass={'c-modal c-modal--iframe'}
          bsSize={'medium'}
          modalBody={bodyContent}
          modalInContainer={false}
          closeButton={false}
        />
      );
    } else if (this.props.errorText === '404') {
      let data = this.props.content.downloadMobileAppForSoftTokenText;
      let header = this.props.content.softTokenErrorHeading;

      if (
        !_.isEmpty(this.state.fromSelectedAccount) &&
        !_.isEmpty(this.state.toSelectedAccount) &&
        _.isEmpty(this.state.selectedPayee)
      ) {
        data = data.replace('<payment>', 'transfer');
        header = header.replace('<payment>', 'transfer');
      } else {
        data = data.replace('<payment>', 'payment');
        header = header.replace('<payment>', 'payment');
      }
      bodyContent = (
        <div className="u-flex u-justify-center">
          <span className="icon icon-attention u-margin-top-b u-margin-bottom-b" />
          <p
            className="text-center"
            dangerouslySetInnerHTML={{ __html: data }}
          />
        </div>
      );
      let footerButtons = (
        <div>
          <div className="u-flex u-justify-center u-margin-bottom-b">
            <button
              type="button"
              onClick={this.reduceAmount}
              className="c-btn c-btn--default c-btn--secondary c-modal__button"
            >
              {this.props.content.reduceAmountButton}
            </button>
          </div>
          <p
            className="text-center"
            dangerouslySetInnerHTML={{
              __html: this.props.content.knowMoreText,
            }}
          />
        </div>
      );
      return (
        <PatternLibModalComponent
          show={this.props.showErrorModalState}
          customClass={'c-modal'}
          onHide={this.hideErrorPopUp}
          bsSize={'large'}
          modalHeading={header}
          modalBody={bodyContent}
          modalInContainer={false}
          modalFooter={footerButtons}
          closeButton
        />
      );
    } else {
      let footerButtons;
      bodyContent = <p>{this.props.errorText}</p>;
      footerButtons = (
        <div>
          <button
            type="button"
            onClick={this.closeErrorModal}
            className="c-btn c-btn--default c-modal__button"
          >
            OK
          </button>
        </div>
      );
      return (
        <PatternLibModalComponent
          show={this.props.showErrorModalState}
          customClass={'c-modal'}
          onHide={this.hideErrorPopUp}
          bsSize={'medium'}
          modalHeading={modalTitle}
          modalBody={bodyContent}
          modalFooter={footerButtons}
          modalInContainer={false}
          closeButton
        />
      );
    }
  }
  renderMoveMoneySME() {
    const { showQuickLink } = this.state;
    const lgGridCols = showQuickLink ? 18 : 24;
    const { payeeList, hasPaymentCapability, session, paymentAuthList } =
      this.props;

    return (
      <Column xs={24} lg={lgGridCols}>
        <MoveMoneySME
          {...this.props}
          payees={payeeList.beneficiaries}
          session={session}
          envConfig={envConfig}
          isBatchPayment={this.props.isBatchPayment}
          hasPaymentCapability={hasPaymentCapability}
          paymentAuthList={paymentAuthList}
          hideQuickLinks={this.hideQuickLinks}
          showQuickLinks={this.showQuickLinks}
        />
      </Column>
    );
  }
  renderSelectedFromAccount(account) {
    let componentName;
    let selectedAccount = this.state.fromSelectedAccount;
    let selectedPotData = MoveMoneyStore.getSelectedPotOfFromAccount(
      selectedAccount.id
    );
    if (!MoveMoneyBL.isSavingAccount(account)) {
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentA'; // Other than Saving Account with nickname available
      } else {
        componentName = 'componentB'; // Other tan Saving Account without nickname
      }
    } else {
      // COnditions for Saving Account // TODO check else if condition remove MoveMoneyStore.isSavingTotClicked() dependency
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentC'; // Saving Account with nickname available
      } else if (!_.isEmpty(selectedPotData)) {
        // MoveMoneyStore.isSavingTotClicked() ===  false OR selected pot name is 'Not in Pot' TODO
        componentName = 'componentD'; // Saving without nickname and 'Clicked Total amount'
      } else {
        componentName = 'componentE'; // Saving without nickname
      }
    }

    // Logic to show correct format of selected account
    return (
      <div
        className="account-card account-card--noborder"
        id="aria-account-from"
      >
        <SelectedAccountComponent
          componentName={componentName}
          selectedAccount={selectedAccount}
          selectedPotData={selectedPotData}
        />
      </div>
    );
  }
  renderSelectedPayee(selectedPayee) {
    return (
      <div
        className="account-card account-card--payee account-card--noborder"
        id="aria-payee-to"
      >
        <dl className="account-card__data">
          <dt className="account-card__data__name">Payee nickname</dt>
          <dd className="account-card__payeename">
            {MoveMoneyBL.getPayeeDisplayName(selectedPayee)}
          </dd>

          <dt className="account-card__data__name">Payee account number</dt>
          <dd className="account-card__number">
            {MoveMoneyBL.getPayeeDisplayNumber(selectedPayee)}
          </dd>

          <dt className="account-card__data__name">Payee reference</dt>
          <dd className="account-card__reference">
            {this.state.originalReference || selectedPayee.reference}
          </dd>
        </dl>
      </div>
    );
  }
  renderSelectedToAccount(account) {
    let componentName;
    let selectedAccount = this.state.toSelectedAccount;
    let selectedPotData = MoveMoneyStore.getSelectedPotOfToAccount(
      selectedAccount.id
    );
    if (!MoveMoneyBL.isSavingAccount(account)) {
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentA'; // Other than Saving Account with nickname available
      } else {
        componentName = 'componentB'; // Other tan Saving Account without nickname
      }
    } else {
      // COnditions for Saving Account // TODO check else if condition remove MoveMoneyStore.isSavingTotClicked() dependency
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentC'; // Saving Account with nickname available
      } else if (!_.isEmpty(selectedPotData)) {
        // MoveMoneyStore.isSavingTotClicked() ===  false OR selected pot name is 'Not in Pot' TODO
        componentName = 'componentD'; // Saving without nickname and 'Clicked Total amount'
      } else {
        componentName = 'componentE'; // Saving without nickname
      }
    }

    // Logic to show correct format of selected account
    return (
      <div className="account-card account-card--noborder" id="aria-account-to">
        <SelectedAccountComponent
          componentName={componentName}
          selectedAccount={selectedAccount}
          selectedPotData={selectedPotData}
        />
      </div>
    );
  }

  // If More than 5 accoounts then display 'Show More'
  renderShowMoreButtonFrom() {
    if (this.state.showMoreLimit < this.props.fromAccounts.length) {
      return (
        <div tabIndex="-1">
          <button
            className="c-btn c-btn--link type--uist u-no-padding"
            onClick={this.fromShowMoreClicked}
            onKeyDown={this.checkKeyPress}
            aria-label="Show additional accounts"
          >
            Show more
          </button>
        </div>
      );
    }
    return '';
  }

  // Effective Warning Methods
  handleEwActions(type, details) {
    let data;
    switch (type) {
      case 'REVIEW_CONTINUE':
        data = {
          continueOnReview: details.val,
        };
        break;
      case 'ERROR':
        data = {
          effectiveWarningError: true,
        };
        break;
      case 'ON_REVIEW':
        data = {
          onEWReview: details.val,
          ewCurrentPage: details.page,
        };
        break;
      case 'CLEAR_MODAL_CONFIG':
        SiteHeaderActionCreator.setModalConfig({
          displayLeavePopup: false,
        });
        data = {
          onEWReview: false,
          ewCurrentPage: '',
        };
        break;
      case 'CANCEL_PAYMENT':
        MoveMoneyStore.resetPaymentData();
        data = this.initialState();
        break;
      default:
        data = {};
        break;
    }

    this.setState(data);
  }

  showEditPayeePage() {
    this.setState({ showEditPayee: true, copCheckClicked: true });
  }

  hideEditPayeePage() {
    this.setState({
      showEditPayee: false,
      copCheckClicked: false,
      fromNoPreviousCOP: false,
    });
  }

  handleCOPClick() {
    const { cop_account_type, cop_account_name } = this.state.selectedPayee;
    const missingCOPData = !cop_account_type || !cop_account_name;
    if (this.state.selectedPayee) {
      this.setupStore();
    }
    if (missingCOPData) {
      this.setState({
        showEditPayee: true,
        copCheckClicked: true,
        fromNoPreviousCOP: true,
      });
    } else {
      this.setState({
        callCOP: true,
        copCheckClicked: true,
        fromNoPreviousCOP: true,
      });
    }
  }

  handleEditSuccess(newValues) {
    if (newValues) {
      this.setState((state) => ({
        selectedPayee: { ...state.selectedPayee, ...newValues },
      }));
    }
    MoveMoneyStore.resetAfterEditPayment();
    MoveMoneyStore.makePaymentToThisPayee();
    this.hideEditPayeePage();
  }

  editCOPSuccess() {
    this.setState({ showCOPTile: false });
  }

  render() {
    const { showSoftTokenAlternative, isSMEUser, content } = this.props;
    const {
      showQuickLink,
      continueOnReview,
      showReview,
      callCOP,
      showEditPayee,
      copCheckClicked,
      showCOPTile,
      editPayeeDetails,
    } = this.state;

    const overlayClassName = cx({
      'c-overlay overlay__custom--zindex': true,
      overlay__show: this.state.fromOpened || this.state.toOpened,
    });
    const iconQuick = 'icon-quickLinks';
    let bodyContent2 = (
      <p>
        If you use your credit card, there will be a cash advance fee to pay of
        3% (min £3). The cash advance interest rate will also apply as per your
        credit card agreement. Please contact us for further information.
      </p>
    );
    let footerButtons2 = (
      <div>
        <button
          onClick={this.closed}
          className="c-btn c-btn--secondary c-modal__button"
          data-anchor="confirm-cancel-button"
          type="button"
        >
          Cancel
        </button>
        <button
          onClick={this.creditokClick}
          className="c-btn c-btn--default c-modal__button"
          data-anch
          or="confirm-cancel-button"
          type="button"
        >
          OK
        </button>
      </div>
    );
    let reviewModal2 = 'c-modal';
    let modalHeading2 = '';
    let bodyContent3 = (
      <p>
        {"You can't transfer more money out of a pot than is actually in it"}
      </p>
    );
    let footerButtons3 = (
      <button
        onClick={this.closePotPopUp}
        className="c-btn c-btn--default c-modal__button"
        data-anchor="confirm-cancel-button"
        type="button"
      >
        OK
      </button>
    );
    let reviewModal3 = 'c-modal';
    let modalHeading3 = '';
    const pageType = showSoftTokenAlternative
      ? 'softTokenAlternative'
      : 'review';

    const isBiller = this.state.selectedPayee.hasOwnProperty('biller_id');

    return (
      <div onFocus={this.trackFocusIn}>
        {this.state.showLoader || this.isStepUpLoading() ? (
          this.showLoader()
        ) : this.props.showThankYouPage ? (
          <ThankYou
            content={this.props.content}
            gotToMoveMoneyPageFlag={this.refreshMoveMoney}
            handleRefreshForRepeatingPotPaymentSetup={
              this.handleRefreshForRepeatingPotPaymentSetup
            }
            managePayee={this.navigateToManagePayee}
            ManagePayments={this.navigateToManagePayments}
            viewLoader={this.props.viewLoader}
            linkClicked={this.linkClicked}
          />
        ) : showEditPayee && copCheckClicked ? (
          <EditPayeePage
            payeeData={this.state.selectedPayee}
            content={this.props.content}
            goToViewPage={this.showViewPayeePage}
            goToMoveMoneyPage={this.handleEditSuccess}
            goToManagePayee={this.navigateToManagePayee}
            billerEdit={!!isBiller}
            isSMEUser={this.props.isSMEUser}
            COP={this.state.copCheckClicked}
            showCopComponent={this.showCopComponent}
            renderCopComponent={this.renderCopComponent}
            session={this.props.session}
            user={this.state.user}
            envConfig={this.props.envConfig}
            editCOPSuccess={this.editCOPSuccess}
            nestedCopEdit={this.handleCopResult}
            nestedEditData={editPayeeDetails}
            nestedContinue={this.continueClick}
          />
        ) : (
          <div
            className="container move-money"
            id="site-main"
            role="main"
            tabIndex="-1"
          >
            {this.state.potError ? (
              <PatternLibModalComponent
                show={this.state.potError}
                customClass={reviewModal3}
                onHide={() =>
                  this.setState({
                    potError: false,
                  })
                }
                bsSize={'medium'}
                modalHeading={modalHeading3}
                modalBody={bodyContent3}
                modalFooter={footerButtons3}
                modalInContainer={false}
                closeButton
              />
            ) : (
              ''
            )}
            {this.state.confirmCancel ? (
              <PatternLibModalComponent
                show={this.state.confirmCancel}
                customClass={reviewModal2}
                onHide={() =>
                  this.setState({
                    confirmCancel: false,
                  })
                }
                bsSize={'medium'}
                modalHeading={modalHeading2}
                modalBody={bodyContent2}
                modalFooter={footerButtons2}
                modalInContainer={false}
                closeButton
              />
            ) : (
              ''
            )}
            {this.state.reviewManagePopUp && (
              <NavigationConfirmationModal
                leavePage={this.leavePage}
                stayOnPage={this.stayOnPage}
                modalConfig={this.getLeaveModalConfig()}
              />
            )}
            {this.props.showErrorModalState && this.renderErrorModal()}

            {!isSMEUser && !callCOP && !SessionStore.isStepUpMode() && (
              <MoveMoneyPageHeader
                showReview={showReview}
                headerText={
                  this.props.content[`${pageType}HeaderTitleMoveMoney`]
                }
                subHeaderText={this.props.content[`${pageType}HeaderMsg`]}
                onBackClick={this.onReviewBack}
                onEWReview={this.state.onEWReview}
                ewCurrentPage={this.state.ewCurrentPage}
              />
            )}

            <div className="row pos-r move-money__inner">
              {isSMEUser ? (
                this.renderMoveMoneySME()
              ) : callCOP ? (
                this.renderCopComponent()
              ) : SessionStore.isStepUpMode() ? (
                this.renderStepUpComponent()
              ) : (
                <div className="col-lg1-18">
                  {/* overlay is open wheb from or To list is shown */}
                  <div
                    ref="overlay"
                    className={overlayClassName}
                    onClick={this.overlayclick}
                  />
                  {(!showReview || this.state.onEWReview) && (
                    <div className="move-money__process pos-r">
                      {this.fromComponent()}
                      {this.toComponent()}
                      {this.amountField()}
                    </div>
                  )}
                  {showCOPTile && !showReview && (
                    <div className="move-money__process pos-r">
                      <div className="move-money__no_previous_check">
                        <NoPreviousCOPTile
                          showAddPayeePage={this.handleCOPClick}
                          confirmationOfPayeeContent={
                            content.confirmationOfPayeeContent
                          }
                        />
                      </div>
                    </div>
                  )}
                  {showSoftTokenAlternative && (
                    <div className="move-money__form row">
                      <VerificationContainer
                        onCancel={() =>
                          this.handleTokenResponse({ data: 'cancel' })
                        }
                        onSuccess={() =>
                          this.handleTokenResponse({ data: 'success' })
                        }
                      />
                    </div>
                  )}
                  <form
                    className={cx({
                      'move-money__form row': !continueOnReview,
                    })}
                  >
                    <div className={cx({ 'col-lg1-18': !continueOnReview })}>
                      {/* If amount available then only show payment component */}
                      {this.checkFormValid() &&
                        !showReview &&
                        this.showRepeatPayment()}
                      {showReview &&
                        !showSoftTokenAlternative &&
                        this.showReviewPayment()}
                    </div>
                  </form>
                </div>
              )}
              {showQuickLink && !callCOP && !SessionStore.isStepUpMode() && (
                <div className="col-lg1-6 move-money__sidebar">
                  <div className="row">
                    {!showReview && (
                      <div className="col-lg1-24 col-md1-12 col-sm1-24">
                        {AccountsStore.getManagePaymentsFlag() ||
                        AccountsStore.getManagePayeesFlag() ? (
                          <Panel
                            SideBarlist={this.getSideNavData(isSMEUser)}
                            linkClicked={this.linkClicked}
                            iconClass={iconQuick}
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                    {UserManagementStore.isBusinessUser() && (
                      <div className="col-lg1-24 col-md1-12 col-sm1-24">
                        <div className="move-money__chat">
                          <GenericChatComponent
                            content={getChatContent(this.props.content)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
MoveMoneyFromToComponent.propTypes = {
  amountFocus: PropTypes.bool,
  isBatchPayment: PropTypes.bool,
  viewLoader: PropTypes.bool,
  otpButton: PropTypes.bool,
  fromAccounts: PropTypes.oneOf([PropTypes.object, PropTypes.array]),
  content: PropTypes.object,
  toAccounts: PropTypes.oneOf([PropTypes.object, PropTypes.array]),
  payeeList: PropTypes.object,
  showAddPayeePage: PropTypes.func,
  editClickFromPayee: PropTypes.func,
  deletePayeeClick: PropTypes.func,
  callPaymentService: PropTypes.func,
  showSoftTokenAlternative: PropTypes.bool,
  disableSoftTokenAlternative: PropTypes.func,
  navigateToManagePayee: PropTypes.func,
  hideErrorPopUp: PropTypes.func,
  hasPaymentCapability: PropTypes.bool,
  isSMEUser: PropTypes.bool,
  showErrorModalState: PropTypes.bool,
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
  paymentAuthList: PropTypes.array,
  handleRefreshForRepeatingPotPaymentSetup: PropTypes.func,
};
MoveMoneyFromToComponent.defaultProps = {
  fromAccounts: [],
  toAccounts: [],
  payeeList: {},
  content: {},
  isSMEUser: false,
  hasPaymentCapability: false,
  amountFocus: false,
  viewLoader: false,
  otpButton: false,
  showSoftTokenAlternative: false,
  showErrorModalState: false,
};

export default MoveMoneyFromToComponent;
